import React, { useState, useEffect } from 'react';
import styles from '../../styles/Desktop.module.css';
import Recepti from '../ApplicationContent/Recepti';
import Messenger from '../ApplicationContent/Messenger';
import WeightGraph from '../ApplicationContent/WeightGraph';
import GlucozeGraph from '../ApplicationContent/Glucoze';
import PreasureGraph from '../ApplicationContent/Bloodpreasure';
import RestInfo from '../ApplicationContent/Restinfo';

import * as firebase from 'firebase/app';

//let data: any;
const Users = (props) => {
  
  let userId = props.data // getting UID
  let name = props.name // user name

  //let ind = props.idata // getting index WHY ??
  
  const [showRecepti, setShowRecepti] = useState(false);
  const [showMessages, setShowMessages] = useState(false);
  const [showWeightGraph, setShowWeightGraph] = useState(false);
  // NEW elements
  const [showRestInfo, setShowRestInfo] = useState(false);
  const [showGlucozeGraph, setShowGlucozeGraph] = useState(false);
  const [showPreasureGraph, setShowPreasureGraph] = useState(false);

  const [lastWeight, setLastWeight] = useState(); // getting last weight

  //const [userUID, setUserUID] = useState();

  useEffect(() => {
    console.log("how many times it turns off FB.DB.off")
    firebase.database().ref('/users/').off("value");
  }, [])

  // removes recepti when u click on new user !!
  useEffect(() => {
    setShowRecepti(false);
    setShowMessages(false);
    setShowWeightGraph(false);
    setShowRestInfo(false);
    setShowGlucozeGraph(false);
    setShowPreasureGraph(false);
  }, [userId])

  // when clicking on recepti 
  //let recepti = null;
  //let messages = null;

  const getReceptiHandler = () => {
    //setUserUID(userId)
    setShowMessages(false);
    setShowWeightGraph(false);
    setShowRestInfo(false);
    setShowGlucozeGraph(false);
    setShowPreasureGraph(false);
    setShowRecepti(true);
    console.log("Recepti click")
    //console.log("RCUID: " + userUID);
    console.log("RCId: " + userId)
  }
  const getMessagesHandler = () => {
    //setUserUID(userId)
    setShowRecepti(false);
    setShowWeightGraph(false);
    setShowRestInfo(false);
    setShowGlucozeGraph(false);
    setShowPreasureGraph(false);
    setShowMessages(true);
    console.log("Messages click")
    //console.log("RCUID: " + userUID);
    console.log("RCId: " + userId)
  }
  const getWeightHandler = () => {
    //setUserUID(userId)
    setShowRecepti(false);
    setShowMessages(false);
    setShowRestInfo(false);
    setShowGlucozeGraph(false);
    setShowPreasureGraph(false);
    setShowWeightGraph(true);
    console.log("Weight graph click")
    //console.log("RCUID: " + userUID);
    console.log("RCId: " + userId)
  }
  const getRestInfoHandler = () => {
    //setUserUID(userId)
    setShowRecepti(false);
    setShowMessages(false);
    setShowWeightGraph(false);
    setShowGlucozeGraph(false);
    setShowPreasureGraph(false);
    setShowRestInfo(true);
    console.log("RestInfo click")
    console.log("RCId: " + userId)
  }
  const getGlucozeHandler = () => {
    //setUserUID(userId)
    setShowRecepti(false);
    setShowMessages(false);
    setShowWeightGraph(false);
    setShowRestInfo(false);
    setShowPreasureGraph(false);
    setShowGlucozeGraph(true);
    console.log("RestInfo click")
    console.log("RCId: " + userId)
  }
  const getPreasureHandler = () => {
    //setUserUID(userId)
    setShowRecepti(false);
    setShowMessages(false);
    setShowWeightGraph(false);
    setShowRestInfo(false);
    setShowGlucozeGraph(false);
    setShowPreasureGraph(true);
    console.log("RestInfo click")
    console.log("RCId: " + userId)
  }
  const getLastWeightHandler = (getLastWeight) => {
    setLastWeight(getLastWeight);
  }

  return  (
    <div className={styles.Desktop}>
      <div className={styles.List}>
        <h4>Uporabnik: {props.name}</h4>
        {
          // for now all LIST then SEPERATE and put UID INSIDE !!
          // <p>{userId}</p>
        }
        <div className={styles.DesktopIcons}> 
          <img className={styles.Icons} src={require('../../icons/weight.png')} alt="Weight icon" />
          <p onClick={() => getRestInfoHandler()}>Osnovne informacije</p>
        </div>
        <div className={styles.DesktopIcons}>
          <img className={styles.Icons} src={require('../../icons/analytic.png')} alt="Meritve icon" />
          <h4>Meritve</h4>
        </div>
        <div className={styles.DesktopIconsSmall}> 
          <img className={styles.IconsS} src={require('../../icons/weight.png')} alt="Weight icon" />
          <p onClick={() => getWeightHandler()}>Telesna Masa</p>
        </div>
        <div className={styles.DesktopIconsSmall}>
          <img className={styles.IconsS} src={require('../../icons/drop.png')} alt="Glucoze icon" />
          <p onClick={() => getGlucozeHandler()}>Krvni sladkor</p>
        </div>
        <div className={styles.DesktopIconsSmall}>
          <img className={styles.IconsS} src={require('../../icons/heartbeat.png')} alt="Heartbeat icon" />
          <p onClick={() => getPreasureHandler()}>Pritisk</p>
        </div>
        <div className={styles.DesktopIcons}>
          <img className={styles.Icons} src={require('../../icons/pills.png')} alt="Pills icon" />
          <h4 onClick={() => getReceptiHandler()}>Recepti</h4>
        </div>
        <div className={styles.DesktopIcons}>
          <img className={styles.Icons} src={require('../../icons/help.png')} alt="Chat bubble icon" />
          <h4 onClick={() => getMessagesHandler()}>Sporočila</h4>
        </div>
        
      </div>
      {showRecepti ? <Recepti data={userId} /> : null}
      {showMessages ? <Messenger data={userId} /> : null}
      {showWeightGraph ? <WeightGraph data={userId} getLW={getLastWeightHandler} /> : null}
      {showRestInfo ? <RestInfo data={userId} passLW={lastWeight} name={name} /> : null}
      {showGlucozeGraph ? <GlucozeGraph data={userId} /> : null}
      {showPreasureGraph ? <PreasureGraph data={userId} /> : null}
    </div>
  ) 
}

export default Users;
